import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { InitialState, InitialStatus } from './initialState';
import { RequestStoreData } from './requestStore.type';

const useRequestStore = create<RequestStoreData>()(
  devtools(set => ({
    data: InitialState,
    requestStatus: InitialStatus,
    token: null,
    caller: null,
    signatureMode: null,
    actions: {
      getDataRequest: request => set(store => ({ ...store, data: request })),
      setRequestStatus: status => set(store => ({ ...store, requestStatus: status })),
      setToken: token => set(store => ({ ...store, token })),
      setCaller: caller => set(store => ({ ...store, caller })),
      setSignatureMode: signatureMode => set(store => ({ ...store, signatureMode })),
    },
  })),
);

export default useRequestStore;
